import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchContacts, fetchMoreContacts, fetchTags } from "../../../redux/action";
import CreateContactSlider from "../../../components/Contacts/CreateContactSlider";
import DeleteContactModal from "../../../components/Contacts/DeleteContactModal";
import EditContactSlider from "../../../components/Contacts/EditContactSlider";
import ContactsTable from "../../../components/Contacts/ContactsTable";
import ReminderContactSlider from "../../../components/Contacts/ReminderContactSlider";
import { Box } from "@chakra-ui/react";

function Contacts() {
  const contacts = useSelector((state) => state.contacts);
  const [filteredContacts, setFilteredContacts] = useState(contacts);
  const dispatch = useDispatch();

  const [query, setQuery] = useState("");
  const [selectedContact, setSelectedContact] = useState({});

  const handleQuerySubmit = (e) => {
    if (e.key === "Enter") {
      // let newList={data:[]};
      //   let updatedContacts=contacts.data.filter((contact)=>contact.full_name.toLocaleLowerCase().includes(query))
      //   newList.data=updatedContacts
      //   setFilteredContacts(newList)
      dispatch(fetchContacts(query));
    }
  };

  const handleQuerySubmitBtn = () => {
    // let newList={data:[]};
    //     let updatedContacts=contacts.data.filter((contact)=>contact.full_name.toLocaleLowerCase().includes(query))
    //     newList.data=updatedContacts
    //     setFilteredContacts(newList)
    dispatch(fetchContacts(query));
  };
  const handleSelectedContact = (contact) => {
    setSelectedContact(contact);
  };

  const handleEditContact = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setSelectedContact({
      ...selectedContact,
      [key]: value,
    });
  };

  // useEffect(()=>{
  //   setFilteredContacts(contacts)
  // },[contacts])
  const fetchContactsData = () => {
    dispatch(fetchContacts());
    dispatch(fetchTags())
  };

  useEffect(() => {
    fetchContactsData();

    //setFilteredContacts(contacts)
  }, []);

  const handleChangeQuery = (e) => {
    setQuery(e.target.value.toLocaleLowerCase());
    if (e.target.value == "") {
      setQuery("");
      dispatch(fetchContacts());
    }
  };

  function handleScroll() {
    //alert("hi")
    const container = document.getElementById("contactsList");

    console.log(container.scrollHeight - container.scrollTop);
    console.log(container.clientHeight);
    if (
      parseInt(container.scrollHeight - container.scrollTop) ===
      container.clientHeight
    ) {
      // alert("heres")
      if (contacts?.meta.current_page < contacts?.meta.last_page)
        dispatch(fetchMoreContacts(query));
    }
  }

  return (
    <>
      <div className="row mt-4">
        <div
          id="contactsList"
          onScroll={handleScroll}
          className="col-md-12 col-lg-12 col-sm-12 col-xs-12 main-section-scroll-height">
          <div className="row pt-1">
            <div className="col-md-6 col-lg-6 col-sm-12 co-xs-12">
              <div className="input-group tags mb-3">
                <input
                  type="text"
                  className="form-control "
                  placeholder="&#xF002;  Search here..."
                  style={{ fontFamily: "Arial, FontAwesome" }}
                  aria-label="Text input with dropdown button"
                  value={query}
                  onChange={handleChangeQuery}
                  onKeyDown={handleQuerySubmit}
                />
                <button
                  className="btn btn-outline-secondary "
                  type="button"
                  onClick={handleQuerySubmitBtn}>
                  Search
                </button>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-sm-12 co-xs-12">
              <div className="d-flex justify-content-end align-items-center">
                <button
                  className="secondary-btn"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#createContactCanvas"
                  aria-controls="createContactCanvas">
                  Create Contact
                </button>
              </div>
            </div>
          </div>
          <ContactsTable
            contacts={contacts}
            handleSelectedContact={handleSelectedContact}
          />
          {/* {!contacts.isLoading? <ContactsTable  contacts={filteredContacts} handleSelectedContact={handleSelectedContact}/>:<div className="loading"></div>} */}
        </div>
      </div>
      <CreateContactSlider />
      <EditContactSlider
        setSelectedContact={setSelectedContact}
        selectedContact={selectedContact}
        handleEditContact={handleEditContact}
      />
      <DeleteContactModal selectedContact={selectedContact} />
      <ReminderContactSlider selectedContact={selectedContact} />
    </>
  );
}

export default Contacts;
